import { createApi } from "@reduxjs/toolkit/query/react";

import { oktaTokenBaseQuery } from "@/react/services/api";

const encryptionUrl = "/v1/encrypt";

export const encryptSecretsApi = createApi({
  reducerPath: "encryptSecrets",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (build) => ({
    encryptText: build.query({
      query: (text) => ({
        url: encryptionUrl,
        method: "POST",
        body: text,
      }),
    }),
  }),
});

export const { useLazyEncryptTextQuery } = encryptSecretsApi;
